import { render } from "./ModalTemplate.vue?vue&type=template&id=ef552f34"
import script from "./ModalTemplate.vue?vue&type=script&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__